export default __webpack_public_path__ + "static/media/pl.9400273d.svg";